import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const FaqAccordion = ({ items, testIdPrefix = "faq" }) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="divide-y divide-line border border-line rounded-2xl bg-white shadow-subtle overflow-hidden">
      {items.map((item, i) => {
        const open = openIndex === i;
        return (
          <div key={i}>
            <button
              type="button"
              data-testid={`${testIdPrefix}-question-${i}`}
              aria-expanded={open}
              onClick={() => setOpenIndex(open ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 hover:bg-surface-muted/60 transition-colors"
            >
              <span className="font-heading font-semibold text-base md:text-lg text-brand-deep">{item.q}</span>
              <ChevronDown size={20} className={`faq-chevron shrink-0 text-brand-royal ${open ? "open" : ""}`} aria-hidden="true" />
            </button>
            <div className={`faq-answer ${open ? "open" : ""}`}>
              <div>
                <p className="px-6 pb-5 text-[15px] text-ink-secondary">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
